import React, { SyntheticEvent, useEffect, useState } from "react";

import { Button, CheckboxProps } from "semantic-ui-react";

import CardRehabTreatment from "react-lib/apps/HISV3/RHB/CardRehabTreatment";
import CardRehabTreatmentPerformRecord from "react-lib/apps/HISV3/RHB/CardRehabTreatmentPerformRecord";

import ModLockExpense from "../BIL/ModLockExpense";
import { formatDateToStringBe } from "react-lib/utils/dateUtils";

type CardRehabilitaionTreatmentProps = {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: () => void) => any;
  proxyController: any;
  scannedDocumentController: any;
  goToTab?: MenuType;
  patientData?: any;
  rehabDeviceSlot: any;
  rehabOrderActionLogList: any[];
  rehabOrderAppointmentList?: any;
  rehabTreatmentList: any[];
  rehabTreatmentPerform: any;
  rehabTreatmentPerformList: any[];
  selectedRehabDeviceSlot?: any;
  selectedRehabWorkList: any;
  buttonLoadCheck: any;
  django?: any;
  errorMessage: any;
  languageUX: string;
  masterOptions: any;
  searchedItemListWithKey: any;
  selectedDivision: any;
  selectedEncounter?: any;
  selectedPatient: any;
  userTokenize: any;
};

type MenuType = "treatmentPerformRecord" | "treatmentPlan";

const today = new Date();

const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

const BUTTON_ACTION_SEARCH = `CardRehabTreatmentPerformRecord_SEARCH`; 

const CardRehabilitaionTreatment = (props: CardRehabilitaionTreatmentProps) => {
  const [menu, setMenu] = useState<MenuType>("treatmentPlan");
  const [isIncludePerformed, setIsIncludePerformed] = useState(true);
  const [showOnlyCancelledplan, setShowOnlyCancelledplan] = useState(false);
  const [isIncludePerformedRecord, setIsIncludePerformedRecord] = useState(false);
  const [performStartDate, setPerformStartDate] = useState(formatDateToStringBe(firstDayOfMonth));
  const [performEndDate, setPerformEndDate] = useState(formatDateToStringBe(lastDayOfMonth));

  useEffect(() => {
    if (props.selectedPatient) {
      props.onEvent({
        message: "getRhbTreatment",
        params: {
          btnAction: BUTTON_ACTION_SEARCH,
          performStartDate: performStartDate,
          performEndDate: performEndDate 
        },
      });
    }

    return () => {
      props.onEvent({
        message: "clearRhbTreatment",
        params: {},
      });
    };
  }, [props.selectedPatient?.id]);

  useEffect(() => {
    if (props.goToTab) {
      setMenu(props.goToTab);

      props.setProp("goToTab", "");
    }
  }, [props.goToTab]);

  const handleChangeIncludePerformed = (e: SyntheticEvent, data: CheckboxProps) => {
    setIsIncludePerformed(!!data.checked);
  };

  const handleChangeShowOnlyCancelledplan = (e: SyntheticEvent, data: CheckboxProps) => {
    setShowOnlyCancelledplan(!!data.checked);
  };

  const handleChangeIncludePerformedRecord = (e: SyntheticEvent, data: CheckboxProps) => {
    setIsIncludePerformedRecord(!!data.checked);
  };

  const handleChangePerformStartDate = (newDate: string) => {
    setPerformStartDate(newDate);
  };

  const handleChangePerformEndDate = (newDate: string) => {
    setPerformEndDate(newDate);
  };

  const handleChangeMenu = (selectedMenu: string) => {
    setMenu(selectedMenu as MenuType);
  };

  return (
    <>
      <div style={{ margin: "10px 10px 5px" }}>
        <Button
          color={menu === "treatmentPlan" ? "blue" : undefined}
          onClick={() => {
            handleChangeMenu("treatmentPlan");
          }}
        >
          Treatment Plan
        </Button>
        <Button
          color={menu === "treatmentPerformRecord" ? "blue" : undefined}
          onClick={() => {
            handleChangeMenu("treatmentPerformRecord");
          }}
        >
          Treatment Perform Record
        </Button>
      </div>

      {menu === "treatmentPlan" ? (
        <CardRehabTreatment
          onEvent={props.onEvent}
          setProp={props.setProp}
          proxyController={props.proxyController}
          divisionId={props.selectedDivision?.id}
          isIncludePerformed={isIncludePerformed}
          showOnlyCancelledPlan={showOnlyCancelledplan}
          rehabDeviceSlot={props.rehabDeviceSlot}
          rehabOrderAppointmentList={props.rehabOrderAppointmentList}
          rehabTreatmentList={props.rehabTreatmentList}
          rehabTreatmentPerformList={props.rehabTreatmentPerformList}
          selectedRehabDeviceSlot={props.selectedRehabDeviceSlot}
          buttonLoadCheck={props.buttonLoadCheck}
          errorMessage={props.errorMessage}
          languageUX={props.languageUX}
          masterOptions={props.masterOptions}
          searchedItemListWithKey={props.searchedItemListWithKey}
          selectedPatient={props.selectedPatient}
          onChangeIncludePerformed={handleChangeIncludePerformed}
          onChangeShowOnlyCancelledplan={handleChangeShowOnlyCancelledplan}
          onChangeMenu={handleChangeMenu}
        />
      ) : null}

      {menu === "treatmentPerformRecord" ? (
        <CardRehabTreatmentPerformRecord
          onEvent={props.onEvent}
          setProp={props.setProp}
          scannedDocumentController={props.scannedDocumentController}
          patientData={props.patientData}
          rehabOrderActionLogList={props.rehabOrderActionLogList}
          rehabTreatmentPerform={props.rehabTreatmentPerform}
          rehabTreatmentPerformList={props.rehabTreatmentPerformList}
          selectedRehabWorkList={props.selectedRehabWorkList}
          buttonLoadCheck={props.buttonLoadCheck}
          django={props.django}
          errorMessage={props.errorMessage}
          languageUX={props.languageUX}
          searchedItemListWithKey={props.searchedItemListWithKey}
          selectedEncounter={props.selectedEncounter}
          selectedPatient={props.selectedPatient}
          userTokenize={props.userTokenize}
          isIncludePerformedRecord={isIncludePerformedRecord}
          onChangeIncludePerformedRecord={handleChangeIncludePerformedRecord}
          performStartDate={performStartDate}
          performEndDate={performEndDate}
          onChangePerformStartDate={handleChangePerformStartDate}
          onChangePerformEndDate={handleChangePerformEndDate}
        />
      ) : null}

      <ModLockExpense
        onEvent={props.onEvent}
        setProp={props.setProp}
        buttonLoadCheck={props.buttonLoadCheck}
        errorMessage={props.errorMessage}
      />
    </>
  );
};

CardRehabilitaionTreatment.displayName = "CardRehabilitaionTreatment";

export default React.memo(CardRehabilitaionTreatment);
